import { render, staticRenderFns } from "./input-editor-markdown.vue?vue&type=template&id=68800e2d&scoped=true&"
import script from "./input-editor-markdown.vue?vue&type=script&lang=js&"
export * from "./input-editor-markdown.vue?vue&type=script&lang=js&"
import style0 from "./input-editor-markdown.vue?vue&type=style&index=0&id=68800e2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68800e2d",
  null
  
)

export default component.exports